"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AttachmentsEditField", {
  enumerable: true,
  get: function () {
    return _AttachmentField.AttachmentField;
  }
});
exports.SavingsEditField = exports.TrendGraphDisplayField = exports.TrendGraphEditField = exports.DescriptionEditField = exports.SummaryEditField = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@lingui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _ActionModal = require("../ActionModal.styles");

var _AttachmentField = require("./AttachmentField");

/* eslint-disable @typescript-eslint/strict-boolean-expressions */
const SummaryInput = (0, _styledComponents.default)(_blocks.Input)`
  ${_blocks.typography.displaySmall};
  margin-top: ${_blocks.spacing.default};
`;

const SummaryEditField = props => /*#__PURE__*/_react.default.createElement(SummaryInput, {
  value: props.value,
  onChange: evt => props.setParentValue(evt.currentTarget.value)
});

exports.SummaryEditField = SummaryEditField;

const DescriptionEditField = props => /*#__PURE__*/_react.default.createElement(_blocks.Textarea, {
  rows: 8,
  value: props.value,
  onChange: evt => props.setParentValue(evt.currentTarget.value)
});

exports.DescriptionEditField = DescriptionEditField;

const TrendGraphEditField = props => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_blocks.Body, null, _core.i18n._({
  id: 'inline_edit_action.trend_graph_edit',
  message: `Trend Graph`
})), /*#__PURE__*/_react.default.createElement(_blocks.Input, {
  placeholder: "https://my.graph.com/image.png",
  value: props.value,
  onChange: evt => props.setParentValue(evt.currentTarget.value)
}));

exports.TrendGraphEditField = TrendGraphEditField;

const TrendGraphDisplayField = props => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.value !== '' && /*#__PURE__*/_react.default.createElement(_blocks.Body, {
  style: {
    marginBottom: _blocks.spacing.tight
  }
}, /*#__PURE__*/_react.default.createElement(_ActionModal.AnchorTag, {
  target: "__blank",
  onClick: e => e.stopPropagation(),
  href: props.value
}, _core.i18n._({
  id: 'inline_edit_action.v2.trend_graph_anchor',
  message: `View Report`
}), /*#__PURE__*/_react.default.createElement(_blocks.External, {
  tiny: true
}))), /*#__PURE__*/_react.default.createElement(_blocks.Button, {
  wafer: true
}, _core.i18n._({
  id: 'inline_edit_action.v2.edit_url',
  message: `Edit`
})));

exports.TrendGraphDisplayField = TrendGraphDisplayField;

const SavingsEditField = props => {
  const handleUpdate = (0, _react.useCallback)(val => {
    const newVal = isNaN(Number(val)) ? val : Number(val);
    void props.onSave({
      [props.property]: newVal
    })();
  }, [props.property, props.onSave]);
  return /*#__PURE__*/_react.default.createElement(_blocks.InlineEdit, {
    inputType: "text",
    value: props.value || '0' // NOTE: Workaround for no value
    ,
    onSave: handleUpdate,
    displayComponent: displayProps => /*#__PURE__*/_react.default.createElement("div", {
      title: _core.i18n._({
        id: 'action_detail.inline_edit_prompt',
        message: `Click to edit`
      })
    }, /*#__PURE__*/_react.default.createElement(_blocks.Body, null, props.label), /*#__PURE__*/_react.default.createElement(_blocks.Body, null, /*#__PURE__*/_react.default.createElement("strong", null, props.isCost ? props.unit : null, displayProps.value, !props.isCost ? ` ${props.unit}` : null))),
    editComponent: editProps => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_blocks.Body, null, props.label, " (", props.unit, ")"), /*#__PURE__*/_react.default.createElement(_blocks.Input, {
      type: "number",
      value: editProps.value,
      onChange: evt => editProps.setParentValue(evt.currentTarget.value)
    }))
  });
};

exports.SavingsEditField = SavingsEditField;